import { EUserPermissions } from '@zunta/configurations'

const meta = {
  requiresAuth: true,
  managementOnly: true
}

export default [
  {
    meta: { ...meta, permissions: [EUserPermissions.VIEW_COLLECTIONS] },
    path: 'collections',
    name: 'management-collections',
    redirect: {
      name: 'management-collections-sections-today',
      query: {
        type: 'today'
      }
    },
    component: () => import('@/views/app/management/collections/Collections.vue'),
    children: [
      {
        meta: { ...meta, permissions: [EUserPermissions.VIEW_COLLECTIONS] },
        path: 'today',
        name: 'management-collections-sections-today',
        query: {
          type: 'today'
        },
        component: () => import('@/views/app/management/collections/sections/CollectionsTable.vue')
      },
      {
        meta: { ...meta, permissions: [EUserPermissions.VIEW_COLLECTIONS] },
        path: 'all',
        name: 'management-collections-sections-all',
        query: {
          type: 'all'
        },
        component: () => import('@/views/app/management/collections/sections/CollectionsTable.vue')
      },
      {
        meta: { ...meta, permissions: [EUserPermissions.VIEW_COLLECTIONS] },
        path: 'aging',
        name: 'management-collections-sections-aging',
        component: () => import('@/views/app/management/collections/sections/CollectionsAging.vue')
      }
      // {
      //   meta: { ...meta, permissions: [EUserPermissions.VIEW_COLLECTIONS, EUserPermissions.ACCESS_TO_CLAIMS] },
      //   path: 'aging-2',
      //   name: 'management-collections-sections-aging-2',
      //   component: () => import('@/views/app/management/collections/sections/CollectionsAging2.vue')
      // },
      // {
      //   meta: { ...meta, permissions: [EUserPermissions.VIEW_COLLECTIONS, EUserPermissions.ACCESS_TO_CLAIMS] },
      //   path: 'collections/claims',
      //   name: 'management-collections-claims',
      //   component: () => import('@/views/app/management/collections/sections/CollectionClaims.vue')
      // },
      // {
      //   meta: { ...meta, permissions: [EUserPermissions.VIEW_COLLECTIONS, EUserPermissions.ACCESS_TO_CLAIMS] },
      //   path: 'collections/claim-tasks',
      //   name: 'management-claim-tasks',
      //   component: () => import('@/views/app/management/collections/sections/ClaimTasks.vue')
      // }
    ]
  },
  {
    meta: { ...meta, permissions: [EUserPermissions.REVIEW_COLLECTIONS] },
    path: 'collections/view/:residentId?',
    name: 'management-collection-resident',
    component: () => import('@/views/app/management/collections/CollectionView.vue')
  },
  {
    meta: { ...meta, permissions: [EUserPermissions.VIEW_COLLECTIONS] },
    path: 'collections/view/:residentId/review/:type/:id',
    name: 'collection-mail-review',
    component: () => import('@/views/app/management/collection-mail-review/CollectionMailReview.vue')
  }
]
